var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 29,
    viewBox: "0 0 45 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1896 4.17668V0L0.0976562 5.23983V28.8571L19.9848 24.7563V28.8571L36.7645 25.3638L41.5033 28.8571V24.3766L44.999 23.6932V0L25.1896 4.17668Z",
    fill: "url(#paint0_linear_2033_330)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92188 17.9222L10.1168 11.0117L14.3118 17.9222H5.92188Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7503 18.0734C21.8097 18.0734 23.4792 16.4414 23.4792 14.4283C23.4792 12.4152 21.8097 10.7832 19.7503 10.7832C17.6909 10.7832 16.0215 12.4152 16.0215 14.4283C16.0215 16.4414 17.6909 18.0734 19.7503 18.0734Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1704 10.9353H32.0234V17.9217H39.1704V10.9353Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2922 14.2368L24.3809 17.0828L25.3696 18.0493L28.2809 15.2034L27.2922 14.2368Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6008 10.8274L26.6895 13.6733L27.6782 14.6399L30.5895 11.7939L29.6008 10.8274Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2033_330",
    x1: 41.9495,
    y1: 34.7653,
    x2: 20.1316,
    y2: 10.8288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#F02826"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/IconReport.afcfb9c46f1fd6d8f52e660fcad1786e.svg";
export { ForwardRef as ReactComponent };